
import PageLayout from '@/components/PageLayout';
import Hero from '@/components/Hero';
import Features from '@/components/Features';
import WhyCIPHER from '@/components/WhyCIPHER';
import BlogPreview from '@/components/BlogPreview';
import SEO from '@/components/SEO';
import StructuredData from '@/components/StructuredData';
import { useEffect, useState } from 'react';

const Index = () => {
  // Fix any ID conflicts when the page loads
  useEffect(() => {
    // Always scroll to top on mount to prevent unwanted scroll position
    window.scrollTo(0, 0);

    const contactElements = document.querySelectorAll('[id="contact"]');
    if (contactElements.length > 1) {
      // If there are multiple elements with id="contact", rename one
      contactElements[1].id = 'contact-footer';
    }
  }, []);

  // Back-to-top button state
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowTopBtn(window.scrollY > 200);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <PageLayout>
      <SEO
        title="CIPHER Security | Prevent, Detect, Respond"
        description="CIPHER Security provides comprehensive Cybersecurity Services including Penetration Testing, DevSecOps, Application Security, and Compliance solutions for enterprises worldwide."
        imageUrl="/images/cipher_character_notext.png"
        keywords={[
          'CIPHER Security',
          'Cybersecurity Services',
          'Penetration Testing',
          'DevSecOps Consulting',
          'Application Security Testing',
          'Cloud Security Assessment',
          'Vulnerability Assessment',
          'Security Compliance',
          'SAST DAST SCA',
          'Incident Response',
          'Cybersecurity Consulting',
          'Enterprise Security',
          'Security Audit',
          'Threat Intelligence',
          'Security Training',
          'Risk Management',
          'Cybersecurity Company'
        ]}
      />
      <StructuredData type="organization" />
      <Hero />
      <Features />
      <WhyCIPHER />
      {/* <BlogPreview /> */}

      {/* Back-to-the-top button */}
      {showTopBtn && (
        <button
          onClick={scrollToTop}
          aria-label="Back to top"
          style={{
            position: 'fixed',
            bottom: '2rem',
            right: '2rem',
            zIndex: 1000,
            backgroundColor: 'rgba(15, 23, 42, 0.7)',
            color: 'rgba(255, 255, 255, 0.9)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            borderRadius: '50%',
            width: '3.5rem',
            height: '3.5rem',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(16px) saturate(180%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.4rem',
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            outline: 'none',
            fontWeight: 600,
            opacity: 0.85,
          }}
          onMouseOver={e => {
            e.currentTarget.style.transform = 'translateY(-4px) scale(1.05)';
            e.currentTarget.style.backgroundColor = 'rgba(30, 41, 59, 0.8)';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.25)';
            e.currentTarget.style.boxShadow = '0 12px 40px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)';
            e.currentTarget.style.opacity = '1';
          }}
          onMouseOut={e => {
            e.currentTarget.style.transform = 'translateY(0) scale(1)';
            e.currentTarget.style.backgroundColor = 'rgba(15, 23, 42, 0.7)';
            e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.15)';
            e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)';
            e.currentTarget.style.opacity = '0.85';
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="18 15 12 9 6 15"></polyline>
          </svg>
        </button>
      )}
    </PageLayout>
  );
};

export default Index;
